import about from './about.json'
import blog from './blog.json'
import contact from './contact.json'
import footer from './footer.json'
import general from './general.json'
import header from './header.json'
import home from './home.json'
import projects from './projects.json'

export default {
  translation: {
    about,
    blog,
    contact,
    footer,
    general,
    header,
    home,
    projects,
  },
}
